module.exports = __webpack_public_path__ + "media/images/emblems/Willadingen-coat_of_arms-697d9df1c6b50a1ac38f4ffa5dc4c759.svg";